
import * as React from 'react';
import Link from 'next/link';

export default class HeaderComponent extends React.Component {
    render() {
        return (
            <header className="site-header">
                <div className="header-inner">
                    <Link href="/" className="header-logo">
                        <span className="logo-x">X</span>Convert
                        <span className="logo-divider">|</span>
                        <span className="logo-sub">Unit Converter</span>
                    </Link>
                    <nav className="header-nav">
                        <a href="https://www.xconvert.com">XConvert Home</a>
                        <a href="/time-converter">Time Converter</a>
                    </nav>
                </div>
            </header>
        );
    }
}
